import { useContext } from 'react'
import { SnackbarContext } from './snackbar-context'

const useSnackbar = () => {
  const context = useContext(SnackbarContext)

  const { addSnackbar, removeSnackbar } = context

  return { addSnackbar, removeSnackbar }
}

export { useSnackbar }
